<template>
  <div class="container">
    <div class="searchBox">
      <van-search
        v-model="keyword"
        shape="round"
        background="transparent"
        placeholder="搜索"
        @search="getValue"
        @input="getValue"
      />
    </div>

    <div class="classifyNav">
      <van-tabs
        type="line"
        v-model="type"
        color="#d62f2f"
        title-active-color="#d62f2f"
        line-width="32px"
        line-height="5px"
        @change="typeClick"
        :swipeable="true"
        :swipe-threshold="5"
      >
        <van-tab title="全部"></van-tab>
        <van-tab title="产品"></van-tab>
        <van-tab title="用户"></van-tab>
        <van-tab title="文章"></van-tab>
        <van-tab title="视频"></van-tab>
        <van-tab title="动态"></van-tab>
        <van-tab title="直播"></van-tab>
        <van-tab title="话题"></van-tab>
      </van-tabs>
    </div>

    <div class="listBox">
      <!-- 全部2条 -->
      <div v-if="type == 0">
        <!-- 产品 -->
        <div class="listItem">
          <div class="listItemTop" @click.stop="toMore(1)">
            <div class="listItemTopLeft">{{ keyword }} - 产品</div>
            <div class="listItemTopRight">
              更多
              <div class="iconfont icon-right"></div>
            </div>
          </div>
          <div v-for="(item, index) in glist" :key="index">
            <div
              class="listItemContent"
              @click.stop="toProductDetail(item.GoodsId)"
            >
              <div class="listImg">
                <van-image fit="cover" :src="item.Thumbnail" />
              </div>
              <div class="rightContent">
                <div class="title overFlowTwo">
                  <span
                    v-for="(pitem, pindex) in item.GoodsName"
                    :key="pindex"
                    :class="pitem == keyword ? 'searchHigh' : ''"
                  >
                    {{ pitem }}
                  </span>
                </div>
                <div class="subTitle">{{ item.Headline }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 用户 -->
        <div class="listItem">
          <div class="listItemTop" @click.stop="toMore(2)">
            <div class="listItemTopLeft">{{ keyword }} - 用户</div>
            <div class="listItemTopRight">
              更多
              <div class="iconfont icon-right"></div>
            </div>
          </div>

          <div v-for="(item, index) in plist" :key="index">
            <div
              class="listItemContent"
              @click.stop="toHomepage(item.MemberId)"
            >
              <div class="listAvatarImg">
                <van-image
                  :src="item.Photo"
                  fit="contain"
                  round
                  error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
                ></van-image>
              </div>
              <div>
                <div class="title">
                  <span
                    v-for="(pitem, pindex) in item.NickName"
                    :key="pindex"
                    :class="pitem == keyword ? 'searchHigh' : ''"
                  >
                    {{ pitem }}
                  </span>
                </div>
                <div class="subTitle overFlowTwo">{{ item.Desc }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 文章 -->
        <div class="listItem">
          <div class="listItemTop" @click.stop="toMore(3)">
            <div class="listItemTopLeft">{{ keyword }} - 文章</div>
            <div class="listItemTopRight">
              更多
              <div class="iconfont icon-right"></div>
            </div>
          </div>

          <div v-for="(item, index) in alist" :key="index">
            <div
              class="listItemContent"
              @click.stop="toArticleDetail(item.ContentID)"
            >
              <div class="listImg" v-if="item.Thumbnail">
                <van-image :src="item.Thumbnail" fit="cover"></van-image>
              </div>
              <div>
                <div
                  class="overFlowTwo"
                  :class="item.Thumbnail ? 'title' : 'bigTitle'"
                >
                  <span
                    v-for="(pitem, pindex) in item.Title"
                    :key="pindex"
                    :class="pitem == keyword ? 'searchHigh' : ''"
                  >
                    {{ pitem }}
                  </span>
                </div>
                <div class="subTitle">
                  {{ item.Headline }} {{ item.CreateTimeDesc }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 视频 -->
        <div class="listItem">
          <div class="listItemTop" @click.stop="toMore(4)">
            <div class="listItemTopLeft">{{ keyword }} - 视频</div>
            <div class="listItemTopRight">
              更多
              <div class="iconfont icon-right"></div>
            </div>
          </div>

          <div v-for="(item, index) in vlist" :key="index">
            <div
              class="listItemContent"
              @click.stop="toVideoDetail(item.VodId)"
            >
              <div class="listImg">
                <van-image :src="item.CoverUrl" fit="cover"></van-image>
                <img
                  class="playIcon"
                  src="../../../static/images/index/play.png"
                />
              </div>
              <div>
                <div class="title overFlowTwo">
                  <span
                    v-for="(pitem, pindex) in item.Title"
                    :key="pindex"
                    :class="pitem == keyword ? 'searchHigh' : ''"
                  >
                    {{ pitem }}
                  </span>
                </div>
                <div class="subTitle">
                  {{ item.Headline }} {{ item.CreateTimeStr }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 动态 -->
        <div class="listItem">
          <div class="listItemTop" @click.stop="toMore(5)">
            <div class="listItemTopLeft">{{ keyword }} - 动态</div>
            <div class="listItemTopRight">
              更多
              <div class="iconfont icon-right"></div>
            </div>
          </div>
          <div v-for="(item, index) in dlist" :key="index">
            <div
              class="listItemContent"
              v-if="item.Details != null && item.Details.length > 0"
              @click.stop="
                toDetail(
                  item.PostType,
                  item.PostId,
                  item.ShareType,
                  item.ShareId
                )
              "
            >
              <div class="listImg" v-if="item.Details[0].Thumbnail">
                <van-image
                  :src="item.Details[0].Thumbnail"
                  fit="cover"
                ></van-image>
              </div>
              <div>
                <div class="overFlowTwo title">
                  <span
                    v-for="(pitem, pindex) in item.Content"
                    :key="pindex"
                    :class="pitem == keyword ? 'searchHigh' : ''"
                  >
                    {{ pitem }}
                  </span>
                </div>
                <div class="subTitle">{{ item.Headline }} {{ item.Times }}</div>
              </div>
            </div>
            <div
              v-else
              @click.stop="
                toDetail(
                  item.PostType,
                  item.PostId,
                  item.ShareType,
                  item.ShareId
                )
              "
              style="margin: 13px 0px"
            >
              <div class="overFlowTwo bigTitle">
                <span
                  v-for="(pitem, pindex) in item.Content"
                  :key="pindex"
                  :class="pitem == keyword ? 'searchHigh' : ''"
                >
                  {{ pitem }}
                </span>
              </div>
              <div class="subTitle">{{ item.Headline }} {{ item.Times }}</div>
            </div>
          </div>
        </div>

        <!-- 直播 -->
        <div class="listItem">
          <div class="listItemTop" @click.stop="toMore(6)">
            <div class="listItemTopLeft">{{ keyword }} - 直播</div>
            <div class="listItemTopRight">
              更多
              <div class="iconfont icon-right"></div>
            </div>
          </div>

          <div v-for="(item, index) in livelist" :key="index">
            <mini-program
              class="listItemContent"
              :path="
                '/subpackagelive/pages/liveDetail/liveDetail?id=' + item.LiveId
              "
            >
              <div class="listImg">
                <van-image :src="item.Cover" fit="cover"></van-image>
                <img
                  class="playIcon"
                  src="../../../static/images/index/play.png"
                />
              </div>
              <div>
                <div class="title overFlowTwo">
                  <span
                    v-for="(pitem, pindex) in item.Title"
                    :key="pindex"
                    :class="pitem == keyword ? 'searchHigh' : ''"
                  >
                    {{ pitem }}
                  </span>
                </div>
                <div class="subTitle">
                  {{ item.Headline }} {{ item.StartTimeDesc }}
                </div>
              </div>
            </mini-program>
          </div>
        </div>

        <!-- 话题 -->
        <div class="listItem">
          <div class="listItemTop" @click.stop="toMore(7)">
            <div class="listItemTopLeft">{{ keyword }} - 话题</div>
            <div class="listItemTopRight">
              更多
              <div class="iconfont icon-right"></div>
            </div>
          </div>
          <div v-for="(item, index) in tlist" :key="index">
            <div
              class="listItemContent"
              @click.stop="toTopicDetail(item.TopicId)"
            >
              <div class="listImg">
                <van-image
                  fit="cover"
                  style="width: 90px"
                  :src="item.BackImage"
                />
              </div>
              <div class="rightContent">
                <div class="overFlowTwo title">
                  <span>#</span>
                  <span
                    v-for="(pitem, pindex) in item.TopicName"
                    :key="pindex"
                    :class="pitem == keyword ? 'searchHigh' : ''"
                  >
                    {{ pitem }}
                  </span>
                  <span>#</span>
                </div>
                <div class="overFlowTwo subTitle">
                  <span
                    v-for="(titem, tindex) in item.TopicDesc"
                    :key="tindex"
                    :class="titem == keyword ? 'searchHigh' : ''"
                  >
                    {{ titem }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 产品 -->
      <div class="listItem" v-if="type == 1">
        <div class="listItemTop">{{ keyword }} - 产品</div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="getGoodsListHandle"
        >
          <div v-for="(item, index) in list" :key="index">
            <div
              class="listItemContent"
              @click.stop="toProductDetail(item.GoodsId)"
            >
              <div class="listImg">
                <van-image fit="cover" :src="item.Thumbnail" />
              </div>
              <div class="rightContent">
                <div class="title overFlowTwo">
                  <span
                    v-for="(pitem, pindex) in item.GoodsName"
                    :key="pindex"
                    :class="pitem == keyword ? 'searchHigh' : ''"
                  >
                    {{ pitem }}
                  </span>
                </div>
                <div class="subTitle">{{ item.Headline }}</div>
              </div>
            </div>
          </div>
        </van-list>
      </div>

      <!-- 用户 -->
      <div class="listItem" v-if="type == 2">
        <div class="listItemTop">{{ keyword }} - 用户</div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="getPersonListHandle"
        >
          <div v-for="(item, index) in list" :key="index">
            <div
              class="listItemContent"
              @click.stop="toHomepage(item.MemberId)"
            >
              <div class="listAvatarImg">
                <van-image
                  :src="item.Photo"
                  fit="contain"
                  round
                  error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
                ></van-image>
              </div>
              <div>
                <div class="title">
                  <span
                    v-for="(pitem, pindex) in item.NickName"
                    :key="pindex"
                    :class="pitem == keyword ? 'searchHigh' : ''"
                  >
                    {{ pitem }}
                  </span>
                </div>
                <div class="subTitle overFlowTwo">{{ item.Desc }}</div>
              </div>
            </div>
          </div>
        </van-list>
      </div>

      <!-- 文章 -->
      <div class="listItem" v-if="type == 3">
        <div class="listItemTop">{{ keyword }} - 文章</div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="getArticleListHandle"
        >
          <div v-for="(item, index) in list" :key="index">
            <div
              class="listItemContent"
              @click.stop="toArticleDetail(item.ContentID)"
            >
              <div class="listImg" v-if="item.Thumbnail">
                <van-image :src="item.Thumbnail" fit="cover"></van-image>
              </div>
              <div>
                <div
                  class="overFlowTwo"
                  :class="item.Thumbnail ? 'title' : 'bigTitle'"
                >
                  <span
                    v-for="(pitem, pindex) in item.Title"
                    :key="pindex"
                    :class="pitem == keyword ? 'searchHigh' : ''"
                  >
                    {{ pitem }}
                  </span>
                </div>
                <div class="subTitle">
                  {{ item.Headline }} {{ item.CreateTimeDesc }}
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>

      <!-- 视频 -->
      <div class="listItem" v-if="type == 4">
        <div class="listItemTop">{{ keyword }} - 视频</div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="getVideoListHandle"
        >
          <div v-for="(item, index) in list" :key="index">
            <div
              class="listItemContent"
              @click.stop="toVideoDetail(item.VodId)"
            >
              <div class="listImg">
                <van-image :src="item.CoverUrl" fit="cover"></van-image>
                <img
                  class="playIcon"
                  src="../../../static/images/index/play.png"
                />
              </div>
              <div>
                <div class="title overFlowTwo">
                  <span
                    v-for="(pitem, pindex) in item.Title"
                    :key="pindex"
                    :class="pitem == keyword ? 'searchHigh' : ''"
                  >
                    {{ pitem }}
                  </span>
                </div>
                <div class="subTitle">
                  {{ item.Headline }} {{ item.CreateTimeStr }}
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>

      <!-- 动态 -->
      <div class="listItem" v-if="type == 5">
        <div class="listItemTop">{{ keyword }} - 动态</div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="getPostListHandle"
        >
          <div v-for="(item, index) in list" :key="index">
            <div
              class="listItemContent"
              v-if="item.Details != null && item.Details.length > 0"
              @click.stop="
                toDetail(
                  item.PostType,
                  item.PostId,
                  item.ShareType,
                  item.ShareId
                )
              "
            >
              <div class="listImg">
                <van-image
                  :src="item.Details[0].Thumbnail"
                  fit="cover"
                ></van-image>
              </div>
              <div>
                <div class="overFlowTwo title">
                  <span
                    v-for="(pitem, pindex) in item.Content"
                    :key="pindex"
                    :class="pitem == keyword ? 'searchHigh' : ''"
                  >
                    {{ pitem }}
                  </span>
                </div>
                <div class="subTitle">{{ item.Headline }} {{ item.Times }}</div>
              </div>
            </div>
            <div
              v-else
              @click.stop="
                toDetail(
                  item.PostType,
                  item.PostId,
                  item.ShareType,
                  item.ShareId
                )
              "
              style="margin: 13px 0px"
            >
              <div class="overFlowTwo bigTitle">
                <span
                  v-for="(pitem, pindex) in item.Content"
                  :key="pindex"
                  :class="pitem == keyword ? 'searchHigh' : ''"
                >
                  {{ pitem }}
                </span>
              </div>
              <div class="subTitle">{{ item.Headline }} {{ item.Times }}</div>
            </div>
          </div>
        </van-list>
      </div>

      <!-- 直播 -->
      <div class="listItem" v-if="type == 6">
        <div class="listItemTop">{{ keyword }} - 直播</div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="getLivingListHandle"
        >
          <div v-for="(item, index) in list" :key="index">
            <mini-program
              class="listItemContent"
              :path="
                '/subpackagelive/pages/liveDetail/liveDetail?id=' + item.LiveId
              "
            >
              <div class="listImg">
                <van-image :src="item.Cover" fit="cover"></van-image>
                <img
                  class="playIcon"
                  src="../../../static/images/index/play.png"
                />
              </div>
              <div>
                <div class="title overFlowTwo">
                  <span
                    v-for="(pitem, pindex) in item.Title"
                    :key="pindex"
                    :class="pitem == keyword ? 'searchHigh' : ''"
                  >
                    {{ pitem }}
                  </span>
                </div>
                <div class="subTitle">
                  {{ item.Headline }} {{ item.StartTimeDesc }}
                </div>
              </div>
            </mini-program>
          </div>
        </van-list>
      </div>

      <!-- 话题 -->
      <div class="listItem" v-if="type == 7">
        <div class="listItemTop">{{ keyword }} - 话题</div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="getTopicListHandle"
        >
          <div v-for="(item, index) in list" :key="index">
            <div
              class="listItemContent"
              @click.stop="toTopicDetail(item.TopicId)"
            >
              <div class="listImg">
                <van-image fit="cover" :src="item.BackImage" />
              </div>
              <div class="rightContent">
                <div class="overFlowTwo title">
                  <span>#</span>
                  <span
                    v-for="(pitem, pindex) in item.TopicName"
                    :key="pindex"
                    :class="pitem == keyword ? 'searchHigh' : ''"
                  >
                    {{ pitem }}
                  </span>
                  <span>#</span>
                </div>
                <div class="overFlowTwo subTitle">
                  <span
                    v-for="(titem, tindex) in item.TopicDesc"
                    :key="tindex"
                    :class="titem == keyword ? 'searchHigh' : ''"
                  >
                    {{ titem }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
import { postList } from "@/api/index";
import { postTopicList } from "@/api/topic";
import { mobileLiveList } from "@/api/online";
import miniProgram from "@/components/miniProgram";
import { Tab, Tabs, Image, Search, List } from "vant";
import {
  pList,
  mobileMemberList,
  homeArticleList,
  homeVideoList,
} from "@/api/product";

const getInf = (str, key) =>
  str.replace(new RegExp(`${key}`, "ig"), `%%${key}%%`).split("%%");
export default {
  name: "allSearch",
  components: {
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-image": Image,
    "van-search": Search,
    "van-list": List,
    miniProgram,
  },
  data() {
    return {
      type: 0,
      keyword: "",

      loading: false,
      finished: false,
      error: false,
      pageIndex: 1,
      total: 0,
      list: [],

      glist: [],
      plist: [],
      alist: [],
      vlist: [],
      dlist: [],
      livelist: [],
      tlist: [],
    };
  },
  methods: {
    //开关
    closeCodeClick() {
      this.show = false;
    },

    //产品详情
    toProductDetail(id) {
      this.$router.push({
        path: "/productDetail",
        query: { id: id },
      });
    },

    //个人主页
    toHomepage(mid) {
      this.$router.push({
        path: "/homePage",
        query: { mid: mid },
      });
    },

    //文章详情
    toArticleDetail(id) {
      this.$router.push({
        path: "/articleDetail",
        query: { id: id },
      });
    },

    //视频详情
    toVideoDetail(id) {
      this.$router.push({
        path: "/videoDetail",
        query: { id: id },
      });
    },

    //动态情页
    toDetail(type, id, stype, sid) {
      if (type == 1) {
        this.$router.push({
          path: "/trendDetails",
          query: { tid: id },
        });
      } else if (type == 2) {
        this.$router.push({ path: "/videoDetails", query: { vid: id } });
      } else if (type == 3) {
        if (stype == 2) {
          this.$router.push({
            path: "/videoDetail",
            query: { id: sid },
          });
        } else {
          this.$router.push({
            path: "/articleDetail",
            query: { id: sid },
          });
        }
      } else {
      }
    },

    //话题详情
    toTopicDetail(id) {
      this.$router.push({
        path: "/hotTopicDetails",
        query: { hid: id },
      });
    },

    //输入框值变化
    getValue() {
      if (this.trim(this.keyword)) {
        this.pageIndex = 1;
        this.list = [];
        this.loading = true;
        if (this.loading) {
          if (this.type == 1) {
            this.getGoodsListHandle();
          } else if (this.type == 2) {
            this.getPersonListHandle();
          } else if (this.type == 3) {
            this.getArticleListHandle();
          } else if (this.type == 4) {
            this.getVideoListHandle();
          } else if (this.type == 5) {
            this.getPostListHandle();
          } else if (this.type == 6) {
            this.getLivingListHandle();
          } else if (this.type == 7) {
            this.getTopicListHandle();
          } else {
            this.getGoodsList();
          }
        }
      } else {
      }
    },

    // 去除首尾的空格
    trim(s) {
      return s.replace(/(^\s*)|(\s*$)/g, "");
    },

    //tab切换
    typeClick(name) {
      this.type = name;
      this.pageIndex = 1;
      this.list = [];
      this.loading = true;
      if (this.keyword || this.$route.query.keyword) {
        if (this.loading) {
          if (this.type == 1) {
            this.getGoodsListHandle();
          } else if (this.type == 2) {
            this.getPersonListHandle();
          } else if (this.type == 3) {
            this.getArticleListHandle();
          } else if (this.type == 4) {
            this.getVideoListHandle();
          } else if (this.type == 5) {
            this.getPostListHandle();
          } else if (this.type == 6) {
            this.getLivingListHandle();
          } else if (this.type == 7) {
            this.getTopicListHandle();
          } else {
            this.getGoodsList();
          }
        }
      }
    },

    //更多
    toMore(n) {
      this.type = n;
      this.pageIndex = 1;
      this.list = [];
      if (this.keyword || this.$route.query.keyword) {
        if (this.type == 1) {
          this.getGoodsListHandle();
        } else if (this.type == 2) {
          this.getPersonListHandle();
        } else if (this.type == 3) {
          this.getArticleListHandle();
        } else if (this.type == 4) {
          this.getVideoListHandle();
        } else if (this.type == 5) {
          this.getPostListHandle();
        } else if (this.type == 6) {
          this.getLivingListHandle();
        } else if (this.type == 7) {
          this.getTopicListHandle();
        } else {
        }
      }
    },

    //2个产品
    getGoodsList() {
      var that = this;
      var data = {
        Keyword: that.keyword,
        Page: {
          PageSize: 2,
          PageIndex: that.pageIndex,
        },
        IsExhibition: false,
        IsRecommend: false,
      };
      pList(data).then((res) => {
        var newlist = res.Data.List;
        for (var i = 0; i < newlist.length; i++) {
          var dic = newlist[i];
          var text = dic["GoodsName"];
          dic["GoodsName"] = getInf(text, that.keyword);
        }
        that.glist = newlist;
        that.getPersonList();
      });
    },

    //2个用户
    getPersonList() {
      var that = this;
      var data = {
        Keyword: that.keyword,
        Page: {
          PageSize: 2,
          PageIndex: that.pageIndex,
        },
      };
      mobileMemberList(data).then((res) => {
        var newlist = res.Data.List;
        for (var i = 0; i < newlist.length; i++) {
          var dic = newlist[i];
          var text = dic["NickName"];
          dic["NickName"] = getInf(text, that.keyword);
        }
        that.plist = newlist;
        that.getArticleList();
      });
    },

    //2文章
    getArticleList() {
      var that = this;
      var data = {
        Keyword: that.keyword,
        Page: {
          PageSize: 2,
          PageIndex: that.pageIndex,
        },
      };
      homeArticleList(data).then((res) => {
        var newlist = res.Data.List;
        for (var i = 0; i < newlist.length; i++) {
          var dic = newlist[i];
          var text = dic["Title"];
          dic["Title"] = getInf(text, that.keyword);
        }
        that.alist = newlist;
        that.getVideoList();
      });
    },

    //2视频
    getVideoList() {
      var that = this;
      var data = {
        Keyword: that.keyword,
        Page: {
          PageSize: 2,
          PageIndex: this.pageIndex,
        },
      };
      homeVideoList(data).then((res) => {
        var newlist = res.Data.List;
        for (var i = 0; i < newlist.length; i++) {
          var dic = newlist[i];
          var text = dic["Title"];
          dic["Title"] = getInf(text, that.keyword);
        }
        that.vlist = newlist;
        that.getPostList();
      });
    },

    //2动态
    getPostList() {
      var that = this;
      var data = {
        Type: 2,
        Keyword: that.keyword,
        Page: {
          PageSize: 2,
          PageIndex: that.pageIndex,
        },
      };
      postList(data).then((res) => {
        var newlist = res.Data.List;
        for (var i = 0; i < newlist.length; i++) {
          var dic = newlist[i];
          var text = dic["Content"];
          dic["Content"] = getInf(text, that.keyword);
        }
        that.dlist = newlist;
        that.getLivingList();
      });
    },

    //2直播
    getLivingList() {
      var that = this;
      var data = {
        CategoryId: 0,
        MemberId: 0,
        Keyword: that.keyword,
        Page: {
          PageSize: 2,
          PageIndex: that.pageIndex,
        },
        Recommend: -1,
        SpecialId: -1,
        HasQrcode: 1,
      };
      mobileLiveList(data).then((res) => {
        var newlist = res.Data.List;
        for (var i = 0; i < newlist.length; i++) {
          var dic = newlist[i];
          var text = dic["Title"];
          dic["Title"] = getInf(text, that.keyword);
        }
        that.livelist = newlist;
        that.getTopicList();
      });
    },

    //2话题
    getTopicList() {
      var that = this;
      var data = {
        CateId: 0,
        Type: 1,
        Keyword: that.keyword,
        Page: {
          PageSize: 2,
          PageIndex: that.pageIndex,
        },
      };
      postTopicList(data).then((res) => {
        var newlist = res.Data.List;
        for (var i = 0; i < newlist.length; i++) {
          var dic = newlist[i];
          var text = dic["TopicName"];
          dic["TopicName"] = getInf(text, that.keyword);
          var desc = dic["TopicDesc"];
          dic["TopicDesc"] = getInf(desc, that.keyword);
        }
        that.tlist = newlist;
      });
    },

    //产品列表
    getGoodsListHandle() {
      var that = this;
      var data = {
        Keyword: that.keyword,
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
        IsExhibition: false,
        IsRecommend: false,
      };
      pList(data)
        .then((res) => {
          var list = res.Data.List;
          for (var i = 0; i < list.length; i++) {
            var dic = list[i];
            var text = dic["GoodsName"];
            dic["GoodsName"] = getInf(text, that.keyword);
          }
          if (that.pageIndex == 1) {
            that.list = [...list];
          } else {
            that.list = [...that.list, ...list];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //用户列表
    getPersonListHandle() {
      var that = this;
      var data = {
        Keyword: that.keyword,
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
      };
      mobileMemberList(data)
        .then((res) => {
          var list = res.Data.List;
          for (var i = 0; i < list.length; i++) {
            var dic = list[i];
            var text = dic["NickName"];
            dic["NickName"] = getInf(text, that.keyword);
          }
          if (that.pageIndex == 1) {
            that.list = [...list];
          } else {
            that.list = [...that.list, ...list];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //文章列表
    getArticleListHandle() {
      var that = this;
      var data = {
        Keyword: that.keyword,
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
      };
      homeArticleList(data)
        .then((res) => {
          var list = res.Data.List;
          for (var i = 0; i < list.length; i++) {
            var dic = list[i];
            var text = dic["Title"];
            dic["Title"] = getInf(text, that.keyword);
          }
          if (that.pageIndex == 1) {
            that.list = [...list];
          } else {
            that.list = [...that.list, ...list];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //视频列表
    getVideoListHandle() {
      var that = this;
      var data = {
        Keyword: that.keyword,
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
      };
      homeVideoList(data)
        .then((res) => {
          var list = res.Data.List;
          for (var i = 0; i < list.length; i++) {
            var dic = list[i];
            var text = dic["Title"];
            dic["Title"] = getInf(text, that.keyword);
          }
          if (that.pageIndex == 1) {
            that.list = [...list];
          } else {
            that.list = [...that.list, ...list];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //动态列表
    getPostListHandle() {
      var that = this;
      var data = {
        Type: 2,
        Keyword: that.keyword,
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
      };
      postList(data)
        .then((res) => {
          var list = res.Data.List;
          for (var i = 0; i < list.length; i++) {
            var dic = list[i];
            var text = dic["Content"];
            dic["Content"] = getInf(text, that.keyword);
          }
          if (that.pageIndex == 1) {
            that.list = [...list];
          } else {
            that.list = [...that.list, ...list];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //直播列表
    getLivingListHandle() {
      var that = this;
      var data = {
        CategoryId: 0,
        MemberId: 0,
        Keyword: that.keyword,
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
        Recommend: -1,
        SpecialId: -1,
        HasQrcode: 1,
      };
      mobileLiveList(data)
        .then((res) => {
          var list = res.Data.List;
          for (var i = 0; i < list.length; i++) {
            var dic = list[i];
            var text = dic["Title"];
            dic["Title"] = getInf(text, that.keyword);
          }
          if (that.pageIndex == 1) {
            that.list = [...list];
          } else {
            that.list = [...that.list, ...list];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //话题列表
    getTopicListHandle() {
      var that = this;
      var data = {
        CateId: 0,
        Type: 1,
        Keyword: that.keyword,
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
      };
      postTopicList(data)
        .then((res) => {
          var list = res.Data.List;
          for (var i = 0; i < list.length; i++) {
            var dic = list[i];
            var text = dic["TopicName"];
            dic["TopicName"] = getInf(text, that.keyword);
            var desc = dic["TopicDesc"];
            dic["TopicDesc"] = getInf(desc, that.keyword);
          }
          if (that.pageIndex == 1) {
            that.list = [...list];
          } else {
            that.list = [...that.list, ...list];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },
  },
  mounted() {
    this.keyword = decodeURI(this.$route.query.keyword);
    this.getGoodsList();
  },
};
</script>
<style lang="less" scoped>
.container {
  min-height: 100vh;
  background-color: #f5f5f5;
  .classifyNav {
    font-size: 14px;
    border-top: 1px solid #dddddd;
    background-color: #fff;
    /deep/.van-tab--active {
      font-weight: bold;
    }
    /deep/.van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
      border: none;
    }
  }
  .listBox {
    .listItem {
      padding: 20px 20px 25px 20px;
      background-color: #fff;
      margin-top: 10px;
      .listItemTop {
        font-size: 16px;
        padding-bottom: 17px;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #eee;
        .listItemTopRight {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #999;
          .iconfont {
            font-size: 12px;
          }
        }
      }
      .listItemContent {
        display: flex;
        align-items: center;
        padding: 13px 0px;
        position: relative;
        .listImg {
          /deep/.van-image {
            width: 70px;
            height: 70px;
            margin-right: 15px;
            display: block;
          }
          .playIcon {
            width: 30px;
            height: 30px;
            position: absolute;
            top: 35px;
            left: 20px;
          }
        }
        .listAvatarImg {
          /deep/.van-image {
            display: block;
            width: 70px;
            height: 70px;
            margin-right: 15px;
          }
        }
        .rightContent {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
        }
        .title {
          width: 250px;
          font-size: 15px;
          color: #333;
          .searchHigh {
            color: #d62f2f;
          }
        }
        .bigTitle {
          width: 350px;
          font-size: 15px;
          color: #333;
        }
        .subTitle {
          font-size: 11px;
          color: #999;
          margin-top: 4px;
        }
      }
    }
  }
}
</style>
